import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {connect} from 'react-redux';

const PrivateRoute = ({isLoggedIn}) => {
    return isLoggedIn ? <Outlet /> : <Navigate to="/login" replace />;
};

const mapStateToProps = (state) => ({
    isLoggedIn: state.auth.isLoggedIn
});

export default connect(mapStateToProps)(PrivateRoute);
